import {
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';

import { ZtToggleConfig } from './zt-toggle.model';

@Component({
    selector: 'zt-toggle',
    templateUrl: 'zt-toggle.component.html',
    styleUrls: ['zt-toggle.component.scss'],
})
export class ZtToggleComponent implements OnInit, OnDestroy {
    @Input() value: boolean = false;
    @Input() disabled: boolean = false;
    @Input() config?: ZtToggleConfig;
    @Input() control!: FormControl<boolean>;

    @Output() onChange = new EventEmitter<boolean>();

    private valueChangesSubscription: Subscription = new Subscription();

    ngOnInit() {
        if (this.control) {
            this.value = this.control?.value;
        }
        this.valueChangesSubscription = this.control?.valueChanges.subscribe(
            (newValue: any) => {
                this.value = newValue;
            }
        );
    }

    onChangeListener(newValue: boolean) {
        this.onChange.emit(newValue);
    }

    ngOnDestroy(): void {
        this.valueChangesSubscription?.unsubscribe();
    }
}
